import React from 'react';
var StoreModule = /** @class */ (function () {
    function StoreModule(path, initialState) {
        var _this = this;
        this.reducers = {};
        this.selectors = {};
        this.getMemoValueHook = function () { return function () {
            var _a = React.useReducer(_this.getReducer(), _this.initialState), state = _a[0], dispatch = _a[1];
            return React.useMemo(function () { return [state, dispatch]; }, [state]);
        }; };
        this.useContext = function (contextArg, newActions, newThunks) {
            if (newActions === void 0) { newActions = {}; }
            if (newThunks === void 0) { newThunks = {}; }
            return function () {
                var context = React.useContext(contextArg);
                if (!context) {
                    throw new Error("useCount must be used within a CountProvider");
                }
                var state = context[0], dispatch = context[1];
                var actions = Object();
                if (newActions) {
                    Object.entries(newActions).forEach(function (_a) {
                        var key = _a[0], value = _a[1];
                        actions[key] = function () {
                            var arg = [];
                            for (var _i = 0; _i < arguments.length; _i++) {
                                arg[_i] = arguments[_i];
                            }
                            return dispatch(value.apply(void 0, arg));
                        };
                    });
                }
                var processes = Object();
                if (newThunks) {
                    Object.entries(newThunks).forEach(function (_a) {
                        var key = _a[0], value = _a[1];
                        processes[key] = function () {
                            var args = [];
                            for (var _i = 0; _i < arguments.length; _i++) {
                                args[_i] = arguments[_i];
                            }
                            return value.apply(void 0, args)(dispatch, function () { return state; }, null);
                        };
                    });
                }
                return {
                    state: state,
                    dispatch: dispatch,
                    actions: actions,
                    processes: processes,
                };
            };
        };
        this.path = path;
        this.initialState = initialState;
    }
    StoreModule.prototype.setPayloadAction = function (type, tinyReducer) {
        this.reducers[type] = tinyReducer;
        return function (payload) { return ({ type: type, payload: payload }); };
    };
    StoreModule.prototype.setSimpleAction = function (type, tinyReducer) {
        this.reducers[type] = tinyReducer;
        return function () { return ({ type: type }); };
    };
    StoreModule.prototype.getReducer = function () {
        var _this = this;
        return function (state, action) {
            if (state === void 0) { state = _this.initialState; }
            var thisReducer = _this.reducers[action.type];
            if (thisReducer)
                return thisReducer(state, action);
            return state;
        };
    };
    StoreModule.prototype.helper = function (state, separator) {
        if (separator === void 0) { separator = '.'; }
        return this.resolve(this.path, state, separator);
    };
    StoreModule.prototype.getContext = function () {
        return React.createContext([
            this.initialState,
            function () { return undefined; },
        ]);
    };
    StoreModule.prototype.resolve = function (path, object, separator) {
        if (separator === void 0) { separator = '.'; }
        return path
            .split(separator)
            .reduce(function (r, val) { return (r ? r[val] : undefined); }, object);
    };
    return StoreModule;
}());
export { StoreModule };
//# sourceMappingURL=StoreModule.js.map